import { HTMLAttributes, ReactNode } from 'react';
import { cn } from 'utils/cn';

import useWindowWidth from '../../../../hooks/useWindowWidth';
import AuthNavigationBar, { AuthNavigationBarItem } from '../../navigation/NavigationBar/AuthNavigationBar';

export interface ModalProps extends HTMLAttributes<HTMLDivElement> {
  isTransitionChild?: boolean;
}

const Modal = ({ className, isTransitionChild, ...divProps }: ModalProps) => {
  return (
    <div
      className={cn(
        'mx-8 rounded-2xl bg-white p-8 shadow-xl sm:mx-0 sm:w-[400px]',
        isTransitionChild ? 'w-[calc(100% - 4rem)]' : 'w-full',
        className
      )}
      {...divProps}
    />
  );
};

Modal.displayName = 'AuthPageModal';

export interface AuthPageProps {
  children?: ReactNode;
  navItems?: AuthNavigationBarItem[];
  navChildren?: ReactNode;
  noBlurredBackground?: boolean;
}

/**
 * A shared layout for signin, signup, and onboarding.
 */
const AuthPage = ({ children, navChildren, navItems, noBlurredBackground }: AuthPageProps) => {
  const windowWidth = useWindowWidth();

  return (
    <div
      className={`flex h-full w-full flex-col font-sans ${
        windowWidth > 640 && !noBlurredBackground ? 'bg-black bg-opacity-60 backdrop-blur-[6px]' : 'bg-slate-50'
      } bg-auth-bg bg-cover`}
    >
      {(noBlurredBackground || windowWidth <= 640) && (
        <div className='flex-shrink-0'>
          <AuthNavigationBar items={navItems}>{navChildren}</AuthNavigationBar>
        </div>
      )}
      <div className='flex h-full w-full items-center justify-center'>{children}</div>
    </div>
  );
};

AuthPage.Modal = Modal;

export default AuthPage;
